import React from 'react';
import { useTranslation } from 'react-i18next';
import { PositionChoose, MainTitle } from '../../../../../Shared';

function SelectPosition(props) {
  const { t } = useTranslation();
  const { positionChoose, setPositionChoose, isDisabled, isSpeech } = props;
  return (
    <div>
      <MainTitle fontSize={16}>
        {t('PositionChooseAdminMap')}
      </MainTitle>
      <PositionChoose
        positionChoose={positionChoose}
        setPositionChoose={setPositionChoose}
        isDisabled={isDisabled}
        isSpeech={isSpeech}
      />
    </div>
  );
}

export default SelectPosition;
